import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_generatedpluginloggerserver_7b822292 from 'nuxt_plugin_generatedpluginloggerserver_7b822292' // Source: ./generated.plugin.logger.server.js (mode: 'server')
import nuxt_plugin_generatedpluginloggerclient_15c8b10a from 'nuxt_plugin_generatedpluginloggerclient_15c8b10a' // Source: ./generated.plugin.logger.client.js (mode: 'client')
import nuxt_plugin_plugin_253352ea from 'nuxt_plugin_plugin_253352ea' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_7e712cec from 'nuxt_plugin_plugin_7e712cec' // Source: ./composition-api/plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_32ba1a3a from 'nuxt_plugin_pluginutils_32ba1a3a' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_229d0105 from 'nuxt_plugin_pluginrouting_229d0105' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_62abdeec from 'nuxt_plugin_pluginmain_62abdeec' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_74f0f7c9 from 'nuxt_plugin_cookieuniversalnuxt_74f0f7c9' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_googlegtag_36138c10 from 'nuxt_plugin_googlegtag_36138c10' // Source: ./google-gtag.js (mode: 'client')
import nuxt_plugin_axios_58c5ba21 from 'nuxt_plugin_axios_58c5ba21' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_apexCharts_82662a6c from 'nuxt_plugin_apexCharts_82662a6c' // Source: ../src/plugins/apexCharts.js (mode: 'client')
import nuxt_plugin_nsComponents_1f90e9b4 from 'nuxt_plugin_nsComponents_1f90e9b4' // Source: ../src/plugins/nsComponents.js (mode: 'all')
import nuxt_plugin_jsonViewer_7a5f3a32 from 'nuxt_plugin_jsonViewer_7a5f3a32' // Source: ../src/plugins/jsonViewer.js (mode: 'all')
import nuxt_plugin_uplotChart_e11ecace from 'nuxt_plugin_uplotChart_e11ecace' // Source: ../src/plugins/uplotChart.js (mode: 'client')
import nuxt_plugin_worker_9db791fa from 'nuxt_plugin_worker_9db791fa' // Source: ../src/plugins/worker.js (mode: 'client')
import nuxt_plugin_konva_10697398 from 'nuxt_plugin_konva_10697398' // Source: ../src/plugins/konva.js (mode: 'client')
import nuxt_plugin_katex_352a2ebc from 'nuxt_plugin_katex_352a2ebc' // Source: ../src/plugins/katex.js (mode: 'all')
import nuxt_plugin_init_5aefaeb1 from 'nuxt_plugin_init_5aefaeb1' // Source: ../src/plugins/init.js (mode: 'client')
import nuxt_plugin_meta_7897424c from 'nuxt_plugin_meta_7897424c' // Source: ./composition-api/meta.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"Neuralworks Studio","title":"Neuralworks Studio","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"NeuralWorks Studio"},{"name":"target-level","content":"production"}],"script":[{"src":"https:\u002F\u002Fcdn.plot.ly\u002Fplotly-2.6.3.min.js","body":true,"async":false,"defer":true},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-MBQPWQGD5L","async":true}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"favicon.ico"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Noto+Sans+KR:wght@400;500&display=swap"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Material+Icons|Material+Icons+Outlined|Material+Icons+Two+Tone|Material+Icons+Round|Material+Icons+Sharp&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Orbitron:wght@100;200;300;400;500;600;700&display=swap"}],"style":[]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_generatedpluginloggerserver_7b822292 === 'function') {
    await nuxt_plugin_generatedpluginloggerserver_7b822292(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_generatedpluginloggerclient_15c8b10a === 'function') {
    await nuxt_plugin_generatedpluginloggerclient_15c8b10a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_253352ea === 'function') {
    await nuxt_plugin_plugin_253352ea(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_7e712cec === 'function') {
    await nuxt_plugin_plugin_7e712cec(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_32ba1a3a === 'function') {
    await nuxt_plugin_pluginutils_32ba1a3a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_229d0105 === 'function') {
    await nuxt_plugin_pluginrouting_229d0105(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_62abdeec === 'function') {
    await nuxt_plugin_pluginmain_62abdeec(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_74f0f7c9 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_74f0f7c9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlegtag_36138c10 === 'function') {
    await nuxt_plugin_googlegtag_36138c10(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_58c5ba21 === 'function') {
    await nuxt_plugin_axios_58c5ba21(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_apexCharts_82662a6c === 'function') {
    await nuxt_plugin_apexCharts_82662a6c(app.context, inject)
  }

  if (typeof nuxt_plugin_nsComponents_1f90e9b4 === 'function') {
    await nuxt_plugin_nsComponents_1f90e9b4(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonViewer_7a5f3a32 === 'function') {
    await nuxt_plugin_jsonViewer_7a5f3a32(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_uplotChart_e11ecace === 'function') {
    await nuxt_plugin_uplotChart_e11ecace(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_worker_9db791fa === 'function') {
    await nuxt_plugin_worker_9db791fa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_konva_10697398 === 'function') {
    await nuxt_plugin_konva_10697398(app.context, inject)
  }

  if (typeof nuxt_plugin_katex_352a2ebc === 'function') {
    await nuxt_plugin_katex_352a2ebc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_init_5aefaeb1 === 'function') {
    await nuxt_plugin_init_5aefaeb1(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_7897424c === 'function') {
    await nuxt_plugin_meta_7897424c(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    router.push(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
